import type { KbDocType, PlayArtifact } from "./bizAdvisorService";

/** 引擎 → KB docType:cs_kb 客服 FAQ → qa;copy 文案 → product。 */
export function docTypeForEngine(engine: string): KbDocType {
  return engine === "cs_kb" ? "qa" : "product";
}

/**
 * 把打法 artifacts 组装成切分器认的 KB 文档文本(B3 D3):
 * - cs_kb(qa):每条 → `问：<title>\n答：<content>`,多条用 `\n\n---\n\n` 分隔(切分器 qa pair 边界)。
 * - copy(product):prose,每条 `<title>\n<content>`,块间空行。
 */
export function assembleDoc(engine: string, artifacts: PlayArtifact[]): string {
  if (engine === "cs_kb") {
    return artifacts.map((a) => `问：${a.title}\n答：${a.content}`).join("\n\n---\n\n");
  }
  return artifacts.map((a) => `${a.title}\n${a.content}`).join("\n\n");
}
